export enum UserFeatures {
  COMPANY_REVENUE_HISTORY = 'company-revenue-history',
}
